import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";
import { showOverlay, hideOverlay } from "../plugins/overlay";
import { startAlert } from "../plugins/noty";

// Connects to data-controller="payments"
export default class extends Controller {
  static values = {
    paymentUrl: String,
  };

  processPayment(event) {
    event.preventDefault();
    this.#init();
  }

  async #init() {
    showOverlay();

    const endpoint = this.paymentUrlValue;

    const method =
      this.element.querySelector('input[name="_method"]')?.value ||
      this.element.method;

    const body = JSON.stringify(Object.fromEntries(new FormData(this.element)));

    const request = new FetchRequest(method, endpoint, {
      body,
      responseKind: "json",
    });
    const response = await request.perform();

    try {
      const payload = await response.json;

      if (response.ok) {
        this.#callback(payload);
      } else {
        hideOverlay();
        startAlert("error", payload.error);
      }
    } catch (e) {
      hideOverlay();
      startAlert(
        "error",
        "Diantre, Robin des fermes est dans les choux, une erreur de serveur empêche tristeusement le site de fonctionner. Reviens-plus tard ou actualise la page.",
      );
    }
  }

  #callback(payload) {
    const {
      provider,
      transaction_id: transactionId,
      redirect_to: redirectTo,
    } = payload;

    // NOTE: flow for saferpay provider uses redirect_to in the current implementation
    // because of that it will hit the first branch of this if
    if (redirectTo) {
      Turbo.visit(redirectTo);
      return;
    } else if (provider === "datatrans" && transactionId) {
      this.#openDatatransModal(transactionId);
      // TODO: implement other provider flows here
    }
  }

  #openDatatransModal(transactionId) {
    window.Datatrans.startPayment({
      transactionId,
      loaded: () => {
        hideOverlay();
      },
      closed: () => {
        this.#unapplyDiscount();
      },
      error: () => {
        this.#unapplyDiscount();
      },
    });
  }

  async #unapplyDiscount() {
    // meh path hardcoding
    const request = new FetchRequest("PATCH", "/order/unapply_discount");
    await request.perform();
  }
}
